export const GET_ALL_CLIENTS =
  'pages/coach/userManagement/allUsers/getAllClients'
export const GET_ALL_COACHES =
  'pages/coach/userManagement/allUsers/getAllCoaches'
export const GET_ALL_COMPANY =
  'pages/coach/userManagement/allUsers/getAllCompany'
